// extracted by mini-css-extract-plugin
export default {"signinGoogle":"Login_signinGoogle__P9B9j","signin":"Login_signin__FFIRl","link":"Login_link__sOg7c"};